module.exports = __webpack_public_path__ + "media/packs/images/flags/CO-86d75fc57f59c5d8111be5584db2a6c8.svg";